import { Link } from "react-router-dom";
import { Layout, Menu, Spin } from "antd";
import {
  HomeOutlined,
  UserOutlined,
  FileProtectOutlined,
  ToolOutlined,
  CommentOutlined,
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import "./menu-sider.scss";
import CanShow from "../../can-show";
import useUser from "../../../hooks/useUser";

const MenuSider = ({
  menuCollapsed,
  roles = [],
}: {
  menuCollapsed: boolean | undefined;
  roles: string[];
}) => {
  const { Sider } = Layout;
  const location = useLocation();
  const { user, isLoading } = useUser();

  return (
    <Spin spinning={isLoading} tip={<p>Cargando...</p>}>
      <Sider
        className="admin-sider"
        collapsed={menuCollapsed}
        collapsible
        breakpoint="md"
        collapsedWidth="0"
        width={220}
        style={{ position: "fixed" }}
      >
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[location.pathname]}
          selectedKeys={[location.pathname]}
        >
          <Menu.Item key="/">
            <Link to="/">
              <HomeOutlined />
              <span className="nav-text">Inicio</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="/contracts">
            <Link to="/contracts">
              <FileProtectOutlined />
              <span className="nav-text">Contratos</span>
            </Link>
          </Menu.Item>
          <CanShow roles={["Customer"]}>
            <>
              <Menu.Item
                key="/administration/suppliers"
                style={{ marginLeft: 28 }}
              >
                <Link to="/administration/suppliers">
                  <UserOutlined />
                  <span className="nav-text">Proveedores</span>
                </Link>
              </Menu.Item>
              <Menu.Item key="/administration/users" style={{ marginLeft: 28 }}>
                <Link to="/administration/users">
                  <UserOutlined />
                  <span className="nav-text">Usuarios</span>
                </Link>
              </Menu.Item>
            </>
          </CanShow>
          <Menu.Item key="/comments">
            <Link to="/comments">
              <CommentOutlined />
              <span className="nav-text">Comentarios</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="/administration">
            <CanShow roles={["Admin", "Financial Advisor"]}>
              <Link to="/administration">
                <ToolOutlined />
                <span className="nav-text">Administración</span>
              </Link>
            </CanShow>
          </Menu.Item>
        </Menu>
      </Sider>
    </Spin>
  );
};

export default MenuSider;
